/**
 * Check if the node is after a table
 * @param {Node} doc - The document object
 * @param {Node} node - The node to check
 * @param {Object} selection - The selection object
 * @returns {boolean} - True if the node is after a table, false otherwise
 */
const getTableBeforeParagraph = (doc, paragraph, { from }) => {
    let table;

    doc.nodesBetween(0, from, (node, _pos, parent) => {
        if (node.type.name === "table") {
            table = node;
        }

        if (node === paragraph && table) {
            return true;
        } else if (!node.type.name.includes("table")) {
            if (node.type.name !== "paragraph" && !parent.type.name.includes("table")) {
                table = null;

                return true;
            }
        }
    });

    return table;
};

/**
 * Check if the node is the last node in document
 * @param {Node} doc - The document object
 * @param {Node} node - The node to check
 * @param {Selection} selection - The editor selection
 * @returns {boolean} - True if the node is the last node, false otherwise
 */
const checkIfLastNode = (doc, nodeToCheck, selection) => {
    const { $anchor } = selection;
    const nodeStart = $anchor.before();
    const nodeEnd = nodeStart + nodeToCheck.nodeSize;

    return nodeEnd >= doc.content.size;
};

export { getTableBeforeParagraph, checkIfLastNode };
